import React, { useState } from 'react'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import * as actions from '../actions/TablaCamionesPenalizadosActions'
import { connect } from 'react-redux'
import ClearIcon from '@material-ui/icons/Clear'
import { Dialog } from '@material-ui/core'
import DialogView from '../../../../../Dialogos/DialogView'
import DialogoPenalizacionDelete from '../components/DialogoPenalizacionDelete'

function CancelarPenalizacionCamion (props) {
  const { roles, patente } = props

  const [open, setOpen] = useState(false)

  const handleOpen = () => setOpen(true)

  const handleClose = () => {
    setOpen(false)
  }

  const handleSubmit = async () => {
    const { patente, vencimiento } = props
    props.deletePenalizacion(patente, vencimiento)
    handleClose()
  }

  function onClick () {
    const { patente } = props
    props.buscarDatosPatente(patente)
    handleOpen()
  }

  const rol = roles.filter(roles => roles === 'SUPERVISOR' || roles === 'SUPMANTENIMIENTO' || roles === 'DESARROLLADOR')
  const rolAutorizado = (rol[0] === 'SUPERVISOR' || rol[0] === 'SUPMANTENIMIENTO' || rol[0] === 'DESARROLLADOR')

  return (
    <div key={patente.toString()}>
      {(rolAutorizado) && <div>
        <Dialog
          open={open}
          onClose={handleClose}
          maxWidth='xl'>
          <DialogView
            confirmCallback={handleSubmit}
            cancelCallback={handleClose}
            title='Despenalizar patente'
            content={<DialogoPenalizacionDelete patente={patente} />}
          />

        </Dialog>
        <div>
          <Tooltip title={'Anular penalización'}>
            <IconButton onClick={onClick}>
              <ClearIcon />
            </IconButton>
          </Tooltip>
        </div>
      </div> }
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    motivo: state.camionesIngreso.motivoPenalizacion,
    vencimiento: state.camionesIngreso.vencimientoPenalizacion,
    roles: state.auth.roles
  }
}

const withRedux = connect(mapStateToProps, actions)

export default withRedux(CancelarPenalizacionCamion)
